import React from "react";
import { useTranslation } from "react-i18next";
import { HiOutlineCheckCircle, HiOutlineClock, HiOutlineInformationCircle } from "react-icons/hi2";
import Modal from "./Modal";
import Button from "./Button";
import DialogIntro from "./DialogIntro";
import { SessionEndReason } from "../util/session";

// What the popup says, by why the table connection ended.
const COPY = {
  [SessionEndReason.EXPIRED]: { icon: HiOutlineClock, title: "sessionExpiredTitle", description: "sessionExpiredDescription" },
  [SessionEndReason.TABLE_CLOSED]: { icon: HiOutlineCheckCircle, title: "tableClosedTitle", description: "tableClosedDescription" },
  [SessionEndReason.TABLE_CLOSED_UNCHARGED]: {
    icon: HiOutlineInformationCircle,
    title: "tableClosedTitle",
    description: "tableClosedUnchargedDescription",
  },
};

/**
 * Blocking popup shown when the guest's table connection (OPM token) is no longer valid, or
 * their table has closed.
 * It has no close button and its overlay covers the whole screen, so nothing behind it
 * (e.g. "continue to payment") can be pressed. Its only action reloads the restaurant's
 * menu, so the guest starts again and enters the table code.
 */
const SessionExpiredModal = ({ show, restaurantId, reason }) => {
  const { t } = useTranslation();
  if (!show) return null;
  const copy = COPY[reason] || COPY[SessionEndReason.EXPIRED];

  const restart = () => {
    window.location.assign(
      restaurantId ? `/?restaurant=${encodeURIComponent(restaurantId)}` : "/"
    );
  };

  return (
    <Modal
      isCloseIcon={false}
      isFullscreen={false}
      isBottomButton={false}
      isHeader={false}
      overlayClassName="z-[100]"
      className="p-6 w-full max-w-md m-6 bg-surface"
    >
      <div className="flex flex-col gap-5 text-center" role="alertdialog" aria-labelledby="session-expired-title">
        <DialogIntro
          icon={copy.icon}
          titleId="session-expired-title"
          title={t(copy.title)}
          description={t(copy.description)}
        />
        <Button size="lg" fullWidth onClick={restart}>
          {t("sessionExpiredButton")}
        </Button>
      </div>
    </Modal>
  );
};

export default SessionExpiredModal;
